import { render, staticRenderFns } from "./SystemAdminManagement.vue?vue&type=template&id=ccffda14"
import script from "./SystemAdminManagement.vue?vue&type=script&lang=js"
export * from "./SystemAdminManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports